(function initFaq() {

    const faqItems = document.querySelectorAll(".cw-cowgirl-faq .faq-item");

    if (!faqItems.length) {
        setTimeout(initFaq, 200);
        return;
    }

    faqItems.forEach((item) => {

        const button = item.querySelector(".faq-question");
        const answer = item.querySelector(".faq-answer");

        if (!button || !answer) return;

        answer.style.maxHeight = item.classList.contains("active")
            ? answer.scrollHeight + "px"
            : "0px";

        button.addEventListener("click", function () {

            const isActive = item.classList.contains("active");

            faqItems.forEach((faq) => {
                faq.classList.remove("active");
                const faqAnswer = faq.querySelector(".faq-answer");
                if (faqAnswer) {
                    faqAnswer.style.maxHeight = "0px";
                }
            });

            if (!isActive) {
                item.classList.add("active");
                answer.style.maxHeight = answer.scrollHeight + "px";
            }

        });

    });

    window.addEventListener("resize", function () {
        document.querySelectorAll(".cw-cowgirl-faq .faq-item.active .faq-answer").forEach((answer) => {
            answer.style.maxHeight = answer.scrollHeight + "px";
        });
    });

})();